import store from "../store/store";
import { authActionTypes } from "./saga";
/**
 * @module AuthSaga
 */

/**
 * Sends OTP to the Phone number in payload
 * Type indicates the authentication type login or sign in
 * @param {string} phoneNumber
 * @param {string} type
 */
export function sendOtp(phoneNumber, type) {
  store.dispatch({
    type: authActionTypes.SEND_OTP,
    payload: {
      phoneNumber,
      type
    }
  });
}

/**
 * Verifies OTP from the Phone number in payload
 * clinicName indicates the name from payload
 * Type indicates the authentication type login or sign in
 * @param {string} loginOtp
 * @param {string} clinicName
 * @param {string} phoneNumber
 * @param {string} type
 */
export function verifyOtp(loginOtp, userName, phoneNumber, type) {
  store.dispatch({
    type: authActionTypes.VERIFY_OTP,
    payload: {
      loginOtp,
      userName,
      phoneNumber,
      type
    }
  });
}

/**
 * Login in using OTP from payload
 * @param {object} data
 */
export function putAuthInfo(data) {
  store.dispatch({
    type: authActionTypes.PUT_AUTH_INFO,
    payload: {
      data
    }
  });
}

/**
 * Login in using OTP from payload
 * @param {string} loginOtp
 */
export function login(loginOtp) {
  store.dispatch({
    type: authActionTypes.LOGIN,
    payload: {
      loginOtp
    }
  });
}

/**
 * For logging out of user
 */
export function logout(shouldReload) {
  store.dispatch({
    type: authActionTypes.LOGOUT,
    payload: { shouldReload }
  });
}

/**
 * Clears the credentials after login
 */
export function clearAuthCredentials() {
  store.dispatch({
    type: authActionTypes.CLEAR_AUTH_CREDENTIALS
  });
}

/**
 * set oAuth Access token
 * @param {string} accessToken
 * @param {string} email
 */
export function setOAuthAccessToken(accessToken, email) {
  store.dispatch({
    type: authActionTypes.SET_OAUTH_ACCESS_TOKEN,
    payload: {
      accessToken,
      email
    }
  });
}
/**
 * Update Access token
 * @param {string} accessToken
 */
export function refreshAccessToken(accessToken) {
  store.dispatch({
    type: authActionTypes.REFRESH_ACCESS_TOKEN,
    payload: {
      accessToken
    }
  });
}
/**
 * send oAuth Access code
 * @param {string} accessCode
 */
export function sendOAuthAccessCode(accessCode) {
  store.dispatch({
    type: authActionTypes.SEND_OAUTH_ACCESS_CODE,
    payload: {
      accessCode
    }
  });
}

/**
 * send token
 * @param {string} token
 */
export function switchLoginWithCustomToken(data, navigate) {
  store.dispatch({
    type: authActionTypes.SWITCH_WITH_CUSTOM_TOKEN,
    payload: {
      data,
      navigate
    }
  });
}
